var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompare = function SvgCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2a1 1 0 0 1 1 1v3.82l4.836-.806a1 1 0 0 1 1.032.49l3.579 6.262.026.046c.131.23.247.432.331.653q.111.293.16.6c.036.234.036.467.036.731V15a5 5 0 1 1-10 0v-.204c0-.264 0-.497.036-.73q.05-.31.16-.601a4.7 4.7 0 0 1 .357-.699l2.534-4.433-3.904.65-.035.006-4.567.761 2.866 5.016.026.046c.131.23.247.432.331.653q.11.293.16.6c.036.234.036.467.036.731V17a5 5 0 1 1-10 0v-.204c0-.264 0-.497.036-.73q.05-.309.16-.601c.084-.221.2-.423.33-.653q.015-.022.027-.046l3.579-6.262a1 1 0 0 1 .704-.49L11 7.153V3a1 1 0 0 1 1-1M3.723 15 6 11.016 8.277 15zM9 17H3a3 3 0 1 0 6 0m9-7.984L15.723 13h4.554zM21 15h-6a3 3 0 0 0 6 0",
    clipRule: "evenodd"
  })));
};
export default SvgCompare;